"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styles = require("./styles");

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const CrossCircleIcon = ({
  title,
  ...otherProps
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", { ...otherProps,
  width: "45",
  height: "45",
  viewBox: "0 0 45 45",
  xmlns: "http://www.w3.org/2000/svg",
  children: [title && /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    children: title
  }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
    transform: "scale(1.95652)",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("circle", {
      cx: 11.5,
      cy: 11.5,
      r: 11.5,
      fill: "#dd3148",
      className: "svg-fill-danger"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M6.248 6.248a.847.847 0 011.117-.071l.079.071 9.308 9.308a.847.847 0 01-1.117 1.267l-.079-.071-9.308-9.308a.844.844 0 010-1.196z",
      fill: "#fff",
      fillRule: "nonzero",
      className: "svg-fill-secondary"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M15.556 6.248a.847.847 0 011.267 1.117l-.071.079-9.308 9.308a.847.847 0 01-1.267-1.117l.071-.079 9.308-9.308z",
      fill: "#fff",
      className: "svg-fill-secondary"
    })]
  })]
});

CrossCircleIcon.defaultProps = {
  title: undefined
};

var _default = (0, _styles.colourIcon)(CrossCircleIcon);

exports.default = _default;